import React from "react";
import { JSInputComponent, JSInputProps } from "../JamezzStylesCSSInput";
import FormColor from "../../../../../../components/Forms/FormColor";

function JSColorInput({ name, required }: JSInputProps) {
  return <FormColor name={name} nullable={true} />;
}

export const JSColorInputComponent: JSInputComponent = {
  Component: JSColorInput,
  handlesCssProperties: ["backgroundColor", "color", "borderColor", "textDecorationColor", "fill"],
};
